import styled, { css } from "styled-components"

interface TableProps {
  readonly width?: string
  readonly padding?: string
  readonly noPadding?: boolean
}

export const Table = styled.table<TableProps>`
  width: ${props => (props.width && props.width) || "100%"};
  padding: ${props => (props.padding && props.padding) || (props.noPadding && "0") || "0.5rem"};
`

interface TableHeaderProps {
  readonly white?: boolean
  readonly noBorder?: boolean
}

export const TableHeader = styled.thead<TableHeaderProps>`
  background: ${props => (props.white && "white") || props.theme.light};
  border-top: 1px solid ${props => props.theme.greyBorder};

  ${props =>
    props.noBorder &&
    css`
      border: none;
    `}
`

export const TableBody = styled.tbody`
  overflow-x: scroll;
`
export const TableFooter = styled.tfoot``

interface ThProps {
  readonly fontSize?: string
  readonly padding?: string
  readonly noPadding?: boolean
  readonly secondary?: string
  readonly primary?: string
  readonly textRight?: boolean
  readonly textCenter?: boolean
  readonly textLeft?: boolean
  readonly width?: string
}

export const Th = styled.th<ThProps>`
  font-size: ${props => props.fontSize};
  width: ${props => props.width || "100%"};
  padding: ${props => (props.padding && props.padding) || (props.noPadding && "0") || "inherit"};
  color: ${props => (props.secondary && props.theme.secondary) || (props.primary && props.theme.primary)};
  text-align: ${props =>
    (props.textRight && "right") || (props.textCenter && "center") || (props.textLeft && "left") || "left"};
`

interface TdProps {
  readonly fontSize?: string
  readonly padding?: string
  readonly noPadding?: boolean
  readonly secondary?: string
  readonly primary?: string
  readonly textRight?: boolean
  readonly textCenter?: boolean
  readonly textLeft?: boolean
}

export const Td = styled.td<TdProps>`
  vertical-align: middle !important;
  width: ${props => props.width || "100%"};
  padding: ${props => (props.padding && props.padding) || (props.noPadding && "0") || "inherit"};
  text-align: ${props =>
    (props.textRight && "right") || (props.textCenter && "center") || (props.textLeft && "left") || "left"};
  font-size: ${props => props.fontSize};
  color: ${props => (props.secondary && props.theme.secondary) || (props.primary && props.theme.primary)};
`

interface TrProps {
  readonly background?: string
  readonly grey?: boolean
  readonly light?: boolean
  readonly width?: string
  readonly padding?: string
  readonly noPadding?: boolean
  readonly margin?: string
  readonly noMargin?: boolean
  readonly hoverable?: boolean
  readonly noBorder?: boolean
  readonly borderBottom?: boolean
}

export const Tr = styled.tr<TrProps>`
  background: ${props => props.background || (props.grey && props.theme.grey) || (props.light && props.theme.light)};
  vertical-align: middle !important;
  border-top: 1px solid ${props => props.theme.greyBorder};
  width: ${props => props.width || "100%"};
  padding: ${props => (props.padding && props.padding) || (props.noPadding && "0") || "1rem"};
  margin: ${props => (props.margin && props.margin) || (props.noMargin && "0") || "1rem"};
  ${props =>
    props.hoverable &&
    css`
      &:hover {
        background: rgba(24, 24, 32, 0.05);
        cursor: pointer;
        transition: all ease 0.5s;
      }
    `};
  ${props =>
    props.noBorder &&
    css`
      border: none;
    `}
  ${props =>
    props.borderBottom &&
    css`
      border: none;
      border-bottom: 1px solid ${props => props.theme.greyBorder};
    `}
`
